/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TranslateRequest } from '../../models/translate-request';
import { TranslateResponse } from '../../models/translate-response';

export interface Translate$Params {
      body: TranslateRequest
}

export function translate(http: HttpClient, rootUrl: string, params: Translate$Params, context?: HttpContext): Observable<StrictHttpResponse<TranslateResponse>> {
  const rb = new RequestBuilder(rootUrl, translate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TranslateResponse>;
    })
  );
}

translate.PATH = '/rest/translate';
